import React from 'react';
import { useStyles } from './Header.styles';
import TaskTypeDropdown, { TaskTypeFilterValue } from './TaskTypeDropdown.component';

interface HeaderProps {
  taskTypeFilter: TaskTypeFilterValue;
  onTaskTypeSelect: (value: TaskTypeFilterValue) => void;
  showTaskTypeDropdown: boolean;
}

export const Header: React.FC<HeaderProps> = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.header}>Lista zadań</div>
      {props.showTaskTypeDropdown && (
        <TaskTypeDropdown taskTypeFilter={props.taskTypeFilter} onSelect={props.onTaskTypeSelect} />
      )}
    </div>
  );
};
